import { createSSGApp } from '@quickwire/ssg';
import { routes } from 'vue-router/auto-routes';
import App from './App.vue';
import './styles/main.css';

export const createApp = createSSGApp(App, {
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  },
});
